import { denormalize } from "normalizr";

import { paymentEntry } from "../../../api/schema";

export default state => {
  try {
    const items = state.paymentEntries.ids;
    const denormalized = denormalize(
      { items },
      { items: [paymentEntry] },
      state.entities
    );
    return denormalized.items || [];
  } catch (err) {
    return [];
  }
};
